<template>
  <svg
    width="9"
    height="5"
    viewBox="0 0 9 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="4.53508"
      y1="4.24219"
      x2="0.999547"
      y2="0.706653"
      stroke="#595A5B"
      stroke-linecap="round"
      class="stroke"
    />
    <line
      x1="8.07031"
      y1="0.707107"
      x2="4.53478"
      y2="4.24264"
      stroke="#595A5B"
      stroke-linecap="round"
      class="stroke"
    />
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .stroke {
  stroke: #437be8;
}
.v-list-item--hide svg {
  transform: rotate(180deg);
  transition: all 0.3s ease-in-out;
}
.v-list-item--show svg {
  transform: rotate(0deg);
  transition: all 0.3s ease-in-out;
}
.show-less svg {
  transform: rotate(180deg);
}
.icon-disable svg .stroke {
  stroke: #afafbe;
}
</style>
